import React from "react";
import Logo from "../img/logo.png"; // Adjust path based on your project structure

function LogoComponent(props) {
  return (
    <img 
      src={Logo} 
      alt="VASCO Logo" 
      style={{ height: "150px", width: "auto" }} 
      {...props}
    />
  );
}

export default LogoComponent;

